import { Box, Collapse, IconButton, List, Stack, Typography } from "@mui/material"
import { useState } from "react"
import Iconify from "minimals-template/components/Iconify"
import { Repeat } from "lib/@components/repeat"
import { MissingAmendItem } from "./missing-amend-item"

export function NotReadyScheduleRow({ schedule }) {
    const [expanded, setExpanded] = useState(false)
    const { title, code, missingAmendsKeys = [] } = schedule

    return (
        <Box sx={{ borderBottom: 1, borderColor: "divider", "&:last-child": { borderBottom: 0 } }}>
            <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{ px: 2, py: 1, cursor: "pointer" }}
                onClick={toggleExpanded}
                data-cy="not-ready-schedule-row"
            >
                <Iconify icon="quill:paper" sx={{ width: 24, height: 24, color: "text.secondary" }} />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography variant="subtitle2" noWrap>
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" noWrap>
                        #{code}
                    </Typography>
                </Box>
                <IconButton aria-label={expanded ? "Collapse schedule" : "Expand schedule"} size="small">
                    <Iconify icon={expanded ? "mingcute:up-fill" : "mingcute:down-fill"} />
                </IconButton>
            </Stack>
            <Collapse in={expanded}>
                <Box sx={{ px: 2, pb: 1.5, pl: 7 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                        Missing notes for:
                    </Typography>
                    <List
                        dense
                        disablePadding
                        sx={{
                            listStyleType: "disc",
                            listStylePosition: "inside",
                            "& .MuiListItem-root": { display: "list-item", py: 0 },
                        }}
                    >
                        <Repeat
                            list={missingAmendsKeys}
                            item={<MissingAmendItem schedule={schedule} />}
                            pass="amendsKey"
                        />
                    </List>
                </Box>
            </Collapse>
        </Box>
    )

    function toggleExpanded() {
        setExpanded((prev) => !prev)
    }
}
